export default __webpack_public_path__ + "static/media/host_naviAbsent.45061b20.svg";